module.exports = __webpack_public_path__ + "static/img/CZ.5c4fb849.svg";